import { AccordionChevron, NavLink, NavLinkProps } from "@mantine/core"
import {
  NavigateOptions,
  useMatchRoute,
  useNavigate,
} from "@tanstack/react-router"
import { useUserLocalStorage } from "@/routes/app/-components/use-user-local-storage"

interface Props extends NavLinkProps {
  nodeId: string
  navigateOptions?: NavigateOptions
  initiallyOpened?: boolean
  onClick?: (evt: React.MouseEvent<HTMLAnchorElement>) => void
  disableLink?: boolean
}

export function StyledNavlink({
  nodeId,
  navigateOptions,
  initiallyOpened,
  disableLink,
  ...props
}: Props) {
  const navigate = useNavigate()
  const matchRoute = useMatchRoute()
  const routeMatched = Boolean(matchRoute({ ...navigateOptions, fuzzy: true }))
  const [storedOpened, setStoredOpened] = useUserLocalStorage<
    boolean | undefined
  >({ key: `navlink-${nodeId}-opened`, defaultValue: initiallyOpened })
  const toggleOpened = () => {
    const newValue = !opened
    setStoredOpened(newValue)
  }
  const opened = routeMatched || storedOpened

  return (
    <NavLink
      h="3rem"
      {...props}
      onClick={(evt) => {
        if (disableLink) {
          toggleOpened()
        } else {
          props.onClick && props.onClick(evt)
          navigateOptions && navigate(navigateOptions)
        }
      }}
      rightSection={
        <>
          {props.rightSection}
          {props.children ? (
            <AccordionChevron
              style={{ rotate: "-90deg" }}
              onClick={(e) => {
                e.stopPropagation()
                toggleOpened()
              }}
            />
          ) : null}
        </>
      }
      opened={opened}
      active={!disableLink && routeMatched}
    />
  )
}
